import { __assign, __extends } from "tslib";
import React from 'react';
import Menu from './Menu';
import matchComponent from '../utils/matchComponent';
import chainCallbacks from '../utils/chainCallbacks';
import * as warning from 'warning';
import MenuCloser from './MenuCloser';
/** @deprecated */
var MenuWrapper = /** @class */ (function (_super) {
    __extends(MenuWrapper, _super);
    function MenuWrapper() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.isDropdownMenu = matchComponent(Menu);
        return _this;
    }
    MenuWrapper.prototype.render = function () {
        var _this = this;
        var _a = this.props, onSelect = _a.onSelect, children = _a.children, selectedValue = _a.selectedValue;
        return (React.createElement(MenuCloser, { onClose: this.props.onClose },
            React.createElement("div", { className: this.props.className }, React.Children.map(children, function (child) {
                if (!React.isValidElement(child)) {
                    return child;
                }
                if (_this.isDropdownMenu(child)) {
                    return _this.renderMenu(child, {
                        // Do not pass onClose and rootCloseEvent to the dropdown menu
                        selectedValue: selectedValue,
                        onSelect: onSelect,
                    });
                }
                return child;
            }))));
    };
    MenuWrapper.prototype.renderMenu = function (child, props) {
        var _this = this;
        var ref = function (c) {
            _this.menu = c;
        };
        if (typeof child.ref === 'string') {
            warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' +
                'To apply a ref to the component use the callback signature:\n\n ' +
                'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute');
        }
        else {
            ref = chainCallbacks(child.ref, ref);
        }
        return React.cloneElement(child, __assign(__assign({}, props), { ref: ref }));
    };
    MenuWrapper.prototype.focusNext = function () {
        this.menu && this.menu.focusNext && this.menu.focusNext();
    };
    MenuWrapper.prototype.focusPrevious = function () {
        this.menu && this.menu.focusPrevious && this.menu.focusPrevious();
    };
    return MenuWrapper;
}(React.Component));
export default MenuWrapper;
//# sourceMappingURL=MenuWrapper.js.map